module.exports = __webpack_public_path__ + "img/ck2.e3836e3a.png";